import {initStripeScript} from '@common/utils/script.loader';
import * as Sentry from '@sentry/vue';

export const stripe = {};
const STRIPE_UNAVAILABLE_MESSAGE = 'Payments are unavailable right now. Please disable blockers and try again.';

function getStripeFallback() {
  return {
    init: () => {},
    redirectToCheckout: () =>
      Promise.resolve({
        error: {
          message: STRIPE_UNAVAILABLE_MESSAGE,
        },
      }),
  };
}

function getStripeInstance() {
  if (typeof window === 'undefined' || typeof window.Stripe !== 'function') {
    return getStripeFallback();
  }

  return {
    init: () => {},
    ...window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY),
  };
}

stripe.install = function (Vue) {
  const setStripe = () => {
    Vue.prototype.$stripe = getStripeInstance();
  };

  const init = () => {
    Vue.prototype.$stripe = getStripeFallback();
    return initStripeScript()
      .then(setStripe)
      .catch(error => {
        Sentry.captureException(error);
        Vue.prototype.$stripe = getStripeFallback();
      });
  };

  Vue.prototype.$stripe = {...getStripeFallback(), init: init};
};
